













































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bButtonClose from 'bootstrap-vue/es/components/button/button-close';
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar';
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav';

import Overlay from '@/components/overlay/Overlay.vue';

import SideMenu from './SideMenu.vue';

@Component({
  components: {
    Overlay,
    SideMenu,

    bButtonClose,
    bNavbar,
    bNavbarNav,
  },
})
export default class Sidenav extends Vue {
  public active = false;

  get classObj() {
    return {
      sidenav: true,
      active: this.active,
    };
  }

  public open() {
    this.active = true;
  }

  public close() {
    this.active = false;
  }

  public toggle() {
    this.active = !this.active;
  }
}
